import { useParams } from 'react-router-dom';

import { useGetSupervisorProjectByIdQuery } from '../../api/supervisorProjectsApiSlice';
import type { SupervisorAllocationSummary, SupervisorConcept } from '../../types/response';

interface UseSupervisorProjectOverviewResult {
  projectName: string;
  conditionAreaName: string;
  healthSystemName: string;
  annotatorNames: string[];
  supervisorNames: string[];
  addedConcepts: SupervisorConcept[];
  validationEncounterCount: number;
  testEncounterCount: number;
  trainingEncounterCount: number;
  allocationSummary: SupervisorAllocationSummary[];
  isDataLoading: boolean;
}

export const useSupervisorProjectOverview = (): UseSupervisorProjectOverviewResult => {
  const { projectId } = useParams();

  const {
    data: projectDetailsData,
    isLoading: isProjectDetailsLoading,
    isFetching: isProjectDetailsFetching,
  } = useGetSupervisorProjectByIdQuery(
    { projectId: projectId as string },
    { skip: !projectId || projectId === '' }
  );

  return {
    projectName: projectDetailsData?.data?.basics?.projectName ?? '',
    conditionAreaName: projectDetailsData?.data?.basics?.conditionAreaName ?? '',
    healthSystemName: projectDetailsData?.data?.basics?.healthSystemName ?? '',
    annotatorNames: projectDetailsData?.data?.annotatorNames ?? [],
    supervisorNames: projectDetailsData?.data?.supervisorNames ?? [],
    addedConcepts: (projectDetailsData?.data?.conceptGroups ?? []) as SupervisorConcept[],
    validationEncounterCount: projectDetailsData?.data?.dataSplitSummary?.validationCount ?? 0,
    testEncounterCount: projectDetailsData?.data?.dataSplitSummary?.testCount ?? 0,
    trainingEncounterCount: projectDetailsData?.data?.dataSplitSummary?.trainingCount ?? 0,
    allocationSummary: projectDetailsData?.data?.allocationData ?? [],
    isDataLoading: isProjectDetailsLoading || isProjectDetailsFetching,
  };
};
